import VueFileUploader from '@dafcoe/vue-file-uploader'
import VueVirtualScroller from 'vue-virtual-scroller'
import CalendaryDateTime from '@/components/globals/CalendaryDateTime.vue'
import { vMaska } from 'maska/vue'

export function registerMisc(app) {
  app.use(VueFileUploader)
  app.use(VueVirtualScroller)

  app.directive('maska', vMaska)

  app.component('CalendaryDateTime', CalendaryDateTime)
}
